module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oauthlogin"
  }, [(_vm.user !== null) ? [(_vm.user.photoURL) ? _c('div', [_c('img', {
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.user.photoURL,
      "alt": "avatar"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("登出")])] : [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.enableGoogleLoginFlag) ? [_c('el-button', {
    staticClass: "btn-primary-google",
    attrs: {
      "size": _vm.isPhone ? 'small' : 'large'
    },
    on: {
      "click": _vm.signinWithGoogle
    }
  }, [_c('span', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/google-logo-bg.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Google登入")])])] : _vm._e(), _vm._v(" "), (_vm.enableFacebookLoginFlag) ? [_c('el-button', {
    staticClass: "btn-primary-facebook",
    attrs: {
      "size": _vm.isPhone ? 'small' : 'large'
    },
    on: {
      "click": _vm.signinWithFB
    }
  }, [_c('span', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/facebook-logo.jpg")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Facebook登入")])]), _c('br')] : _vm._e(), _vm._v(" "), (_vm.enableEmailPassLoginFlag) ? [_c('br'), _c('br'), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-0.6rem",
      "background-color": "white"
    }
  }, [_vm._v(" 或 ")]), _vm._v(" "), _c('h3', [_vm._v("以Email登入")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showEmailPassField),
      expression: "!showEmailPassField"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showEmailPassField = true
      }
    }
  }, [_vm._v(" 註冊/登入 ")])] : _vm._e()], 2), _vm._v(" "), (_vm.enableEmailPassLoginFlag) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailPassField),
      expression: "showEmailPassField"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("登入信箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "pwd"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-right",
    on: {
      "click": function($event) {
        _vm.showResetBtn = !_vm.showResetBtn
      }
    }
  }, [_c('u', [_vm._v("登入遇到問題？")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signInWithEmailAndPassword
    }
  }, [_vm._v("登入")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("註冊")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResetBtn),
      expression: "showResetBtn"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入可正常收信的 email 地址"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendResetMail
    }
  }, [_vm._v("取得密碼重設連結")])])])])])] : _vm._e()], 2)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88c69e86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner/OAuthLogin.vue
// module id = 978
// module chunks = 1